import React,{Component} from "react";
import { NavLink } from 'react-router-dom';
import Currency from "../components/component.currency";
import Language from "../components/component.language";
import moment from "moment";
import Global from '../globals/global';
//if (typeof window === "undefined")  var window={}
const $ = window.$;
const location = window.location;
var activestyle={
    fontWeight: "bold",
    color: "orange"
};


export default class footer extends Global {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount(){
           this.setmenuoptions();
           //this.forceUpdate()
    }

    render() {

         var disablepages = this.config().noheaderpages || [];

         const disable = disablepages.find(page => {
                return location.pathname.search(page) != -1;
         })
         if(disable) return null;
         
        return (


 <footer className="revealed footer-area">



  <div className="container">
          <div className="row">


            <div className="col-lg-6 mx-auto d-block">
              <div className="logo_footer_f">
                    <svg preserveAspectRatio="xMidYMid meet" data-bbox="0 -0.141 1438 923.141" viewBox="0 0 1438 923" xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" data-type="ugc" role="presentation" aria-hidden="true">
                      <g>
                          <defs>
                              <linearGradient y2="540.79" x2="672.139" y1="-16.348" x1="785.123" gradientUnits="userSpaceOnUse" id="svgcid-j76z7cpd3h4b">
                                  <stop offset="0" stop-color="#abaaa8"></stop>
                                  <stop offset=".522" stop-color="#cdcbc7"></stop>
                                  <stop offset="1" stop-color="#f0ede7"></stop>
                              </linearGradient>
                          </defs>
                          <path d="M124 332c27-98 117-152 219-188-116 6-294 106-330 247-16 103 55 149 208 63 85-54 159-111 231-168 79-62 157-119 235-169 34-19 67-6 36 51-30 55-60 111-90 167-65 122 4 188 115 116 52-37 98-77 142-120l69-60c51-40 86-33 83 27l-9 105c-1 79 51 100 134 90 111-25 192-65 267-106-212 58-399 125-329-81 42-123 10-172-63-151-39 11-81 32-130 71-58 50-115 101-171 154-66 64-106 52-54-34 28-44 55-87 83-131 18-32 37-63 56-95 43-102 7-138-66-112-71 30-143 71-214 123-107 75-213 150-319 225-65 44-113 36-103-24z" fill="url(#svgcid-j76z7cpd3h4b)"></path>
                          <path d="M12 865h10c4 0 8 1 10 2s4 3 5 5c2 2 2 4 2 6 0 3 0 5-2 7-1 2-2 3-5 5 3 1 5 2 7 3 1 1 2 3 3 5 1 1 1 3 1 5 0 5-1 8-4 11s-7 5-13 5H12v-54zm5 6v17h3c4 0 6-1 8-1 2-1 3-2 4-4 1-1 2-3 2-5s-1-4-3-5c-2-2-4-2-8-2h-6zm0 22v20h6c4 0 7 0 9-1 2 0 3-2 4-3 1-2 2-4 2-5 0-3-1-5-2-7-2-1-4-3-7-3-1-1-5-1-9-1h-3zm79-29c8 0 15 3 20 8 6 6 8 12 8 20s-2 14-8 20c-5 5-12 8-19 8-8 0-15-3-20-8-6-6-8-12-8-20 0-5 1-10 3-14 3-4 6-8 10-10 5-3 9-4 14-4zm0 5c-4 0-7 1-11 3-3 2-6 5-8 9-2 3-3 7-3 11 0 7 2 12 7 16 4 5 9 7 15 7 4 0 8-1 12-3 3-2 6-5 8-8 2-4 3-8 3-12s-1-8-3-11c-2-4-5-7-8-9-4-2-8-3-12-3zm56-4h5v33c0 3 0 6 1 7 0 2 0 4 1 5s3 3 5 4c2 0 4 1 6 1s3 0 5-1c1-1 3-2 4-3 1-2 2-3 2-5 1-1 1-4 1-8v-33h5v33c0 4 0 8-1 11s-3 6-6 8-6 3-10 3-8-1-11-3-5-5-6-8c-1-2-1-6-1-11v-33zm60 6v-6h29v6h-12v48h-5v-48h-12zm53-6h5v54h-5v-54zm78 48l8 10h-6l-6-7c-4 3-9 4-14 4-8 0-15-3-20-8-6-6-8-12-8-20 0-5 1-10 3-14 3-4 6-8 11-10 4-3 8-4 14-4 7 0 14 3 19 8 6 6 8 12 8 20 0 4 0 8-2 11-1 4-4 7-7 10zm-3-4c5-5 7-10 7-17 0-4-1-8-3-11-2-4-5-7-8-9-4-2-7-3-11-3s-8 1-12 3c-3 2-6 5-8 9-2 3-3 7-3 11 0 7 2 12 7 16 4 5 9 7 15 7 5 0 9-1 12-3l-12-15h7l9 12zm40-44h6v40c0 2 1 4 2 5s2 3 4 4c2 0 4 1 6 1s4 0 5-1c2-1 3-2 4-3 1-2 2-3 3-5v-41h5v33c0 4 0 8-1 11s-3 6-5 8c-3 2-7 3-11 3s-7-1-11-3c-3-2-5-5-6-8 0-2-1-6-1-11v-33zm65 0h31v6h-25v16h24v6h-24v20h24v6h-30v-54zm99 0l25 54h-6l-8-18h-23l-9 18h-5l25-54h1zm-1 12l-9 19h18l-9-19zm100-2l-4 4c-3-3-5-6-9-7-3-2-6-3-10-3s-8 1-12 3c-3 2-6 5-8 9-2 3-3 7-3 11 0 7 2 12 6 16 5 5 10 7 17 7 8 0 14-3 19-9l4 3c-3 4-6 6-10 8s-8 3-13 3c-9 0-17-3-22-9s-7-12-7-19c0-8 3-15 8-20 6-5 13-8 21-8 5 0 9 1 13 3s7 5 10 8zm77 0l-4 4c-3-3-5-6-9-7-3-2-6-3-10-3-5 0-8 1-12 3s-6 5-8 9c-2 3-3 7-3 11 0 7 2 12 6 16 5 5 10 7 17 7s14-3 19-9l4 3c-3 4-6 6-10 8s-8 3-13 3c-10 0-17-3-22-9s-7-12-7-19c0-8 3-15 8-20 6-5 12-8 21-8 5 0 9 1 13 3s7 5 10 8zm53-11c8 0 14 3 20 8 5 6 8 12 8 20s-3 14-8 20c-6 5-12 8-20 8s-14-3-20-8c-5-6-8-12-8-20 0-5 1-10 4-14 2-4 6-8 10-10 4-3 9-4 14-4zm0 5c-4 0-8 1-11 3-4 2-7 5-9 9-2 3-2 7-2 11 0 7 2 12 6 16 4 5 10 7 16 7 4 0 8-1 11-3 4-2 6-5 8-8 2-4 3-8 3-12s-1-8-3-11c-2-4-4-7-8-9-3-2-7-3-11-3zm53 50l7-54h1l22 44 21-44h1l8 54h-5l-6-38-18 38h-2l-19-39-5 39h-5zm85 0l7-54h1l22 44 21-44h1l7 54h-5l-5-38-19 38h-1l-19-39-5 39h-5zm112-55c8 0 15 3 20 8 5 6 8 12 8 20s-3 14-8 20c-5 5-12 8-20 8s-14-3-20-8c-5-6-8-12-8-20 0-5 2-10 4-14 3-4 6-8 10-10 4-3 9-4 14-4zm0 5c-4 0-8 1-11 3-4 2-6 5-8 9-2 3-3 7-3 11 0 7 2 12 6 16 5 5 10 7 16 7 4 0 8-1 11-3 4-2 7-5 9-8 2-4 3-8 3-12s-1-8-3-11c-2-4-5-7-9-9-3-2-7-3-11-3zm56 50v-54h11c8 0 13 1 17 2 5 2 9 5 12 10 3 4 4 10 4 16 0 5-1 10-3 14-3 4-5 7-9 9s-9 3-16 3h-16zm5-5h6c7 0 12-1 15-2 4-1 7-3 9-7 3-3 4-7 4-12s-1-10-4-13c-2-4-6-6-10-8-4-1-9-1-17-1h-3v43zm88-49l25 54h-6l-8-18h-23l-8 18h-6l25-54h1zm-1 12l-9 19h18l-9-19zm46-6v-6h29v6h-12v48h-6v-48h-11zm52-6h6v54h-6v-54zm60-1c8 0 15 3 20 8 6 6 8 12 8 20s-2 14-8 20c-5 5-12 8-20 8-7 0-14-3-19-8-6-6-8-12-8-20 0-5 1-10 3-14 3-4 6-8 10-10 5-3 9-4 14-4zm0 5c-4 0-7 1-11 3-3 2-6 5-8 9-2 3-3 7-3 11 0 7 2 12 7 16 4 5 9 7 15 7 4 0 8-1 12-3 3-2 6-5 8-8 2-4 3-8 3-12s-1-8-3-11c-2-4-5-7-8-9-4-2-8-3-12-3zm56 50v-54h1l35 41v-41h6v54h-2l-35-41v41h-5z" fill-rule="nonzero" fill="#ffffff"></path>
                          <path d="M720 779c15 0 28 13 28 29 0 15-13 28-28 28-16 0-29-13-29-28 0-16 13-29 29-29z" fill="#ffffff"></path>
                          <path fill="#ffffff" d="M190 806h390v3H190v-3z"></path>
                          <path d="M661 789c10 0 18 8 18 19 0 10-8 18-18 18s-18-8-18-18c0-11 8-19 18-19z" fill="#ffffff"></path>
                          <path d="M623 795c7 0 12 6 12 13s-5 12-12 12-12-5-12-12 5-13 12-13z" fill="#ffffff"></path>
                          <path d="M595 800c5 0 8 3 8 8 0 4-3 8-8 8-4 0-7-4-7-8 0-5 3-8 7-8z" fill="#ffffff"></path>
                          <path fill="#ffffff" d="M1248 806H858v3h390v-3z"></path>
                          <path d="M777 789c-10 0-18 8-18 19 0 10 8 18 18 18s19-8 19-18c0-11-9-19-19-19z" fill="#ffffff"></path>
                          <path d="M815 795c-7 0-12 6-12 13s5 12 12 12 13-5 13-12-6-13-13-13z" fill="#ffffff"></path>
                          <path d="M843 800c-5 0-8 3-8 8 0 4 3 8 8 8 4 0 8-4 8-8 0-5-4-8-8-8z" fill="#ffffff"></path>
                          <path d="M236 646c0-18-5-33-15-44-11-12-23-20-37-26-15-5-30-9-45-11-8-1-15-2-21-2-7 0-14-1-21-1H84l-5 1H62l-16 1-21-1H6l-4 1s-1 0-2 1c0 0 3 1 7 1h4c1 1 2 1 3 1 2 0 5 1 6 2 4 2 7 6 7 11v120c0 6-2 10-6 13-4 2-8 3-10 3-1 0-3 0-5 1H5c0 1 2 1 6 1h33l5 1h29c8 1 14 1 18 1 6 0 12 0 19-1 4 0 11-1 20-1 15-2 29-5 44-10s28-13 38-23c6-5 11-11 14-18 3-6 5-13 5-21zm-28-1c0 15-4 27-12 37-8 9-18 16-30 21-2 0-5 1-9 3-4 1-7 2-9 2-4 1-7 2-9 2-1 0-4 1-7 1l-2 1c-11 1-22 2-32 2h-6c-16 0-26-2-30-6-5-4-8-8-8-11l-1-116c0-7 8-11 24-11h9c10 0 21 1 35 2 13 2 26 5 39 10 14 6 25 13 34 23 9 11 14 24 14 40zm170 50c0-2-1-3-2-3 0 0-1 0-2 1l-1 3c-2 6-7 10-15 12-8 3-17 4-27 4l-6-1h-6c-16 0-24-4-24-11v-55c0-3 3-5 7-5h35c4 0 8 1 12 2 5 2 8 6 8 11l2 2 1 2c1 0 2-2 2-4v-15s1-1 1-2v-2c1-1 1-1 1-3 2-2 2-4 2-4 0-1 0-1-1-1s-2 0-4 1l-3 3s-2 1-4 1c-2 1-5 1-10 1h-42c-3 0-5-1-6-2-1-2-2-3-2-4v-50c0-3 3-5 9-5h36c4 0 8 1 13 3s8 5 10 10l1 2 1 1h1c1 0 2-1 2-3 0-4 1-7 1-10l2-6c1-2 2-4 2-5s-1-2-2-2-3 0-4 1l-3 1H244v1h-1l6 2h1c2 0 4 0 5 1 2 0 4 1 6 1 4 2 6 4 6 8l-1 130c0 4-2 6-5 8-4 1-6 2-9 2-2 0-3 1-3 2h112c9 0 14-2 14-7 2-4 2-7 2-9l1-7zm172 6c0-2 0-4-1-7 0-2 0-3-1-3s-2 0-2 1l-2 3c-7 11-17 16-31 16h-30c-8 0-14-1-18-3s-7-5-8-8-2-6-2-9V584c0-7 3-12 8-15 5-2 9-3 12-3 4-1 6-2 6-2 0-1-2-1-6-1h-70c-1 0-1 0-1 1h-1s2 1 6 2c5 0 9 1 13 3 5 3 7 7 7 14v112c0 3 0 5-1 7-1 3-2 5-3 6-3 4-6 6-8 7-3 0-5 1-7 1s-3 1-3 2h15l11-1h13l25 1h56c15 0 23-5 23-17zm410 18c0-1 0-1-1-2l-4-1c-5 0-9-1-13-2-4-2-7-3-8-5-4-5-5-9-5-12l-22-132v-2l-1-3c-1-1-1-2-2-2s-3 2-5 5l-91 129-94-129c-2-3-4-4-6-4-1 0-1 0-2 1v3l-22 136c-2 7-4 11-8 14-4 2-7 3-10 3l-5 2h15l17-1 13 1h16c0-1-1-2-4-2-4-1-8-2-10-3-3-2-4-4-5-6 0-2-1-4-1-8l13-97 82 113 2 2c1 1 2 1 3 1 2 0 4-1 5-3l82-115 14 98c0 2 0 3 1 4v2c0 4-1 6-4 8-2 2-4 3-6 3-4 1-6 1-6 2 0 0 1 1 5 1 0-1 1-1 3-1h40l19 1 4 1h1zm228-2h-3l-4-1c-5 0-9-1-13-2-3-1-6-3-8-5-5-5-8-8-9-11l-79-134c-1-2-3-4-4-4-2 0-3 1-3 2-1 0-1 1-1 1 0 1-1 1-1 1l-75 136c-1 3-4 6-8 9-5 4-11 6-21 7l-2 1h-2c0 1 1 1 3 1h64s-1-1-2-1l-4-1c-7-1-11-5-11-9l1-3v-2l21-41c0-2 3-3 7-3h60c3 0 5 1 7 3l23 41c3 4 4 7 4 9s-1 3-4 3c-3 1-5 2-5 2 0 1 1 1 2 1l2 1h63l2-1zm-94-68c0 1-2 1-4 1h-53c-3 0-4 0-4-2 0-1 0-1 1-1l26-52 1-3 1-1c2 0 3 1 4 4l27 52c0 1 1 1 1 2zm344 68c0-1-2-1-5-1-4 0-9-1-17-2-8-2-16-5-23-9l-71-57c4-2 8-4 13-7s11-8 17-15c5-7 8-15 8-25 0-4-1-7-3-11-1-4-3-7-6-9-5-5-11-9-18-12-7-2-14-4-22-5-1 0-2 0-3-1h-46l-18 1-22-1h-16s-1 0-1 1c0 0 2 1 5 2 2 0 4 0 6 1l7 1c6 2 8 4 8 8v124c0 10-4 15-14 16l-4 1h-1l-1 1h16c5-1 12-1 21-1h17l15 1h3v-1h-1c0-1-1-1-1-1-15-1-23-7-23-16v-47h39l63 52c2 3 9 5 18 9 9 3 22 5 38 5h9l9-1h1c1-1 2-1 2-1h1zm-105-110c0 11-2 20-8 26s-12 10-18 11c-6 2-11 3-14 3h-9c-6 0-10 0-14-1-1 0-3-1-5-1h-1c-2 0-4-1-5-2s-1-2-2-3v-67c0-1 1-1 1-2 1 0 3-1 7-1h15c12 0 23 2 34 6s17 13 19 26v5z" fill-rule="nonzero" fill="#ffffff"></path>
                      </g>
                  </svg>
                  <a href="mailto:info@delmarboutique.com">info@delmarboutique.com</a>
              </div>
            </div>	

 

              {/*
            <div className="col-lg-3  col-md-6 col-sm-6">
              <div className="single-footer-widget mail-chimp">
                <h6 className="mb-20">{this.t("Contact")}</h6>
                <ul>

                  <li>
                    <div className="styled-select">
                      <Language header={false} />
                    </div>
                    <div className="styled-select">
                      <Currency header={false} />
                    </div>
                  </li>
                </ul>
              </div>
            </div>	*/}

          </div>

          <div className="row">


            <div className="col-lg-12 d-sm-flex justify-content-center">
              <span className="follow_text">{this.t("Follow us")}</span>

                <a href="https://www.facebook.com/delmarboutiqueaccommodation/" className="social_b" target="_blank">
                    <img
                    src={this.image(
                    "img/delmar/facebook.webp"
                      )}
                  />
                </a>

                <a href="https://www.instagram.com/dlmboutique/" className="social_b" target="_blank">
                    <img
                    src={this.image(
                    "img/delmar/instagram.webp"
                      )}
                  />
                </a>
        
                <a href="https://www.youtube.com/channel/UCltmvsMCEFh2P3BZqfGWxZw" className="social_b" target="_blank">
                    <img
                    src={this.image(
                    "img/delmar/youtube.webp"
                      )}
                  />
                </a>

                <a href="https://www.pinterest.com/delmarboutiqueaccommodation/" className="social_b" target="_blank">
                    <img
                    src={this.image(
                    "img/delmar/pinterest.webp"
                      )}
                  />
              </a>

              <div className="borderb"></div>

              <a href="https://es.delmarboutiqueaccommodation.com/contact" className="btn_footer_c">{this.t("Contact us")}</a>

            </div>



          </div>
          
          <div className="footer-bottom">
            <div className="row align-items-center">
              <div className="col-lg-8 col-sm-12">
               <p class="mt-2 terms_footer"> {this.t("Go to")}:<a href="https://es.delmarboutiqueaccommodation.com/privacypolicies" target="_blank"> {this.t("Privacy Policies")}</a> <a href="https://es.delmarboutiqueaccommodation.com/termsandconditions" target="_blank"> | {this.t("Terms and conditions")}</a></p>
              </div>

              <div className="col-lg-4 col-sm-12 footer-social text-center text-lg-right">
                  <svg preserveAspectRatio="xMidYMid meet" data-bbox="0 0 243 243" viewBox="0 0 243 243" height="18" width="18" xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" data-type="color" role="presentation" aria-hidden="true">
                  <g>
                      <path d="M162 142l18 4c-3 15-10 26-20 33-10 8-22 11-36 11s-26-2-36-8c-9-6-16-14-20-25-5-11-8-23-8-36s3-25 8-36c6-10 14-18 24-23s21-8 32-8c14 0 26 3 35 10s16 16 19 28l-18 5c-3-10-7-17-13-21-6-5-14-7-23-7-10 0-19 2-26 7S86 88 83 96s-4 16-4 25c0 11 2 21 5 30 3 8 9 14 16 18s14 7 23 7c10 0 18-3 25-9s12-14 14-25zM122 0c67 0 121 54 121 122 0 67-54 121-121 121C54 243 0 189 0 122 0 54 54 0 122 0zm0 19c56 0 102 46 102 103 0 56-46 102-102 102-57 0-103-46-103-102C19 65 65 19 122 19z" fill="#ffffff" data-color="1"></path>
                  </g>
              </svg>
              &nbsp;{new Date().getUTCFullYear()} Del Mar Boutique Network
             
              </div>

            </div>
          </div>
        </div>




{/*  <div className='text-center'>v {this.version()}</div> */} 
  
</footer>

        );
    }
}

